import { Component, Input } from '@angular/core'

@Component({
  selector: 'mmx-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  standalone: false,
})
export class ButtonGroupComponent {
  @Input() color: string
}
